<script setup>
  import FormElementMixins from '@/mixins/FormElementMixins'
</script>
<template lang="">
    <div>
        <div class="mb-3">
            <label :for="fieldId" class="form-label" v-if="fieldTitle">{{ fieldTitle }}
                <Popper-X v-if="element.help" arrow>
                  <span class="text-primary mx-2 fs-5">
                      <BIconQuestionSquareFill></BIconQuestionSquareFill>
                  </span>
                  <template v-slot:content>
                      <div v-html="element.help"></div>
                  </template>
</Popper-X>
</label>
<input
  @focus="element.confirm
                ? $confirm({...element.confirm, callback: confirmCallback})
                : () => {}"
  @input="onInput"
  @keydown="onKeydown"
  :data-section="element.section"
  v-model="element.value"
  type="text"
  class="form-control"
  :id="fieldId"
  :key="fieldId"
  :placeholder="element.placeholder"
  :required="element.required"
  :disabled="element.disabled"
>
<div
  class="form-text"
  v-if="element.description && element.collapsed !== true"
>
  {{element.description}}
</div>
</div>
</div>
</template>
<script>
  export default {
    name: "FormElementTextNoSpace",
    mixins: [FormElementMixins],
    methods: {
      confirmCallback(confirm) {
        if (confirm) {
          this.element.confirm = null
        }
      },
      onKeydown(event) {
        const inputElement = event.target;
        const key = event.key;

        // Some native keyboard/composition paths can arrive without a string key.
        if (typeof key !== 'string' || event.isComposing) {
          return true;
        }

        const isNotWithModifier = key.length === 1;

        // is lowercase and not multi key like holding a modifier
        // eslint-disable-next-line no-unused-vars
        const isLowercase = /[a-z]/.test(key) && isNotWithModifier;
        const isSpace = /^\s$/.test(key) && isNotWithModifier;

        // Allow modifier keys
        if (event.metaKey || event.ctrlKey) {
          return true;
        }
        const navigationKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
        if (navigationKeys.includes(key)) {
          return true;
        }

        // Disallow space
        if (isSpace) {
          event.preventDefault();
          return false;
        }

        // if it's lowercase. Change it to uppercase!
        if (isLowercase) {
          // stop the insert
          event.preventDefault();

          // cursor start
          const start = inputElement.selectionStart;
          // cursor end
          const end = inputElement.selectionEnd;
          // input value
          const value = inputElement.value;

          // Insert the uppercase version of the key at the current cursor position
          inputElement.value = value.substring(0, start) + key.toUpperCase() + value.substring(end);

          // Restore the cursor position
          inputElement.selectionStart = inputElement.selectionEnd = start + 1;
          inputElement.dispatchEvent(new Event('input'));

          return true;
        }
      },
      onInput(event) {
        const inputElement = event.target;

        const hasWhitespace = /\s/.test(inputElement.value);

        if (hasWhitespace) {
          inputElement.setCustomValidity("Ingen mellemrum er tilladt i dette felt");
        } else {
          inputElement.setCustomValidity("");
        }
      }
    }
  }

</script>
<style lang="scss"></style>
